export class MultiFactorAuthenticationRequest{ 
    token: number;
    chosenShippingMethod: number;
    idBrowserVisitor: string;
}